export const heroImage =
  "https://readdy.ai/api/search-image?query=warm%20orange%20anime%20style%20illustration%20of%20a%20serene%20ninja%20village%20with%20traditional%20rooftops%20and%20mountains%20under%20a%20golden%20sunset%20sky%2C%20soft%20clouds%20and%20silhouettes%20of%20spinning%20wind%20turbine%20spokes%2C%20atmospheric%20glow%2C%20cinematic%20wide%20composition%2C%20rich%20amber%20and%20coral%20tones%2C%20hand%20painted%20anime%20background%20art%2C%20high%20detail%2C%20dreamy%20and%20evocative&width=1600&height=900&seq=hero-naruto-1&orientation=landscape";

export interface CpCategory {
  id: string;
  name: string;
  tagline: string;
  desc: string;
  workCount: string;
  cover: string;
  themes: string[];
}

export const categories: CpCategory[] = [
  {
    id: "naruto-cp",
    name: "鸣人CP",
    tagline: "阳光少年的羁绊",
    desc: "围绕鸣人与伙伴之间的热血羁绊展开的同人本，以成长、信任与并肩战斗为主线。",
    workCount: "320+ 本",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20orange%20anime%20illustration%20of%20a%20energetic%20blond%20ninja%20boy%20with%20whisker%20marks%20and%20sun%20emblem%20jacket%20grinning%20under%20bright%20sunlight%2C%20konoha%20style%20village%20in%20background%2C%20vibrant%20spirited%20mood%2C%20hand%20painted%20manga%20cover%20art%2C%20warm%20amber%20and%20cream%20palette%2C%20soft%20shading%2C%20high%20detail&width=800&height=1000&seq=cat-naruto-1&orientation=portrait",
    themes: ["热血", "羁绊", "成长"],
  },
  {
    id: "sasuke-cp",
    name: "佐助CP",
    tagline: "深夜里的一抹孤光",
    desc: "以佐助为主线，刻画孤独、复仇与和解的复杂心境，剧情向与情感向作品居多。",
    workCount: "290+ 本",
    cover:
      "https://readdy.ai/api/search-image?query=dark%20moody%20anime%20illustration%20of%20a%20serious%20black%20haired%20ninja%20boy%20with%20sharingan%20eye%20standing%20under%20a%20crimson%20moon%20and%20falling%20petals%2C%20silhouette%20with%20glowing%20red%20accents%2C%20melancholic%20atmosphere%2C%20hand%20painted%20manga%20cover%20art%2C%20deep%20charcoal%20and%20warm%20red%20palette%2C%20high%20contrast%2C%20high%20detail&width=800&height=1000&seq=cat-sasuke-1&orientation=portrait",
    themes: ["复仇", "救赎", "宿命"],
  },
  {
    id: "itachi-sakura",
    name: "鼬樱",
    tagline: "温柔与坚韧的交织",
    desc: "鼬樱向同人本，多聚焦于守护、理解与隐忍的情感张力，画风细腻含蓄。",
    workCount: "180+ 本",
    cover:
      "https://readdy.ai/api/search-image?query=elegant%20anime%20illustration%20of%20cherry%20blossoms%20falling%20over%20a%20mysterious%20ninja%20with%20a%20crimson%20glowing%20eye%20and%20a%20gentle%20female%20figure%2C%20tender%20emotional%20mood%2C%20soft%20pink%20and%20vermilion%20tones%20with%20warm%20light%2C%20hand%20painted%20manga%20cover%20art%2C%20delicate%20brushwork%2C%20romantic%20and%20poetic%2C%20high%20detail&width=800&height=1000&seq=cat-itachi-1&orientation=portrait",
    themes: ["守护", "含蓄", "命运"],
  },
  {
    id: "kakashi-cp",
    name: "卡卡西",
    tagline: "蒙面之下的温柔",
    desc: "卡卡西向同人本，围绕老师身份与过往回忆展开，温情日常与冒险题材并重。",
    workCount: "210+ 本",
    cover:
      "https://readdy.ai/api/search-image?query=calm%20anime%20illustration%20of%20a%20silver%20haired%20masked%20ninja%20with%20an%20eyepatch%20and%20hitai-ate%20headband%20holding%20a%20ninja%20dog%20plush%2C%20soft%20morning%20light%20through%20misty%20forest%2C%20relaxed%20gentle%20mood%2C%20hand%20painted%20manga%20cover%20art%2C%20silvery%20grey%20and%20warm%20sand%20palette%2C%20soft%20shading%2C%20high%20detail&width=800&height=1000&seq=cat-kakashi-1&orientation=portrait",
    themes: ["日常", "回忆", "师恩"],
  },
  {
    id: "shikamaru-cp",
    name: "鹿丸",
    tagline: "懒散天才的聪明日常",
    desc: "鹿丸向同人本，节奏轻松又带点小机智，战术头脑与性格反差是最大看点。",
    workCount: "150+ 本",
    cover:
      "https://readdy.ai/api/search-image?query=playful%20anime%20illustration%20of%20a%20chilled%20ninja%20boy%20with%20a%20ponytail%20and%20cloud%20emblem%20jacket%20sitting%20under%20a%20large%20tree%20watching%20clouds%2C%20daydreaming%20lazy%20mood%2C%20light%20tan%20and%20teal%20cloud%20pattern%20motif%2C%20hand%20painted%20manga%20cover%20art%2C%20warm%20neutral%20palette%2C%20soft%20sunlight%2C%20high%20detail&width=800&height=1000&seq=cat-shikamaru-1&orientation=portrait",
    themes: ["轻松", "机智", "反差"],
  },
  {
    id: "gaara-cp",
    name: "我爱罗",
    tagline: "沙与孤岛的和解",
    desc: "我爱罗向同人本，聚焦孤独、守护与重新学会信任，沙的意象贯穿始终。",
    workCount: "160+ 本",
    cover:
      "https://readdy.ai/api/search-image?query=serene%20anime%20illustration%20of%20a%20red%20haired%20young%20ninja%20with%20tanuki%20marks%20standing%20in%20a%20desert%20with%20flowing%20sand%20whirlwinds%20under%20a%20golden%20dusk%20sky%2C%20lonely%20yet%20peaceful%20mood%2C%20hand%20painted%20manga%20cover%20art%2C%20warm%20amber%20and%20sand%20palette%2C%20drifting%20sand%20particles%2C%20high%20detail&width=800&height=1000&seq=cat-gaara-1&orientation=portrait",
    themes: ["孤独", "守护", "和解"],
  },
];

export interface WorkItem {
  id: string;
  title: string;
  author: string;
  category: string;
  tags: string[];
  rating: string;
  summary: string;
  cover: string;
}

export const hotWorks: WorkItem[] = [
  {
    id: "hot-1",
    title: "木叶的午后",
    author: "影山桑",
    category: "鸣人CP",
    tags: ["日常", "温暖", "清水"],
    rating: "9.2",
    summary: "一场发生在木叶村夏日午后的普通故事，鸣人与伙伴们之间的信任在琐碎日常里悄悄生长。",
    cover:
      "https://readdy.ai/api/search-image?query=cozy%20anime%20illustration%20of%20two%20friends%20sharing%20a%20yakisoba%20lunch%20on%20a%20warm%20afternoon%20rooftop%20in%20a%20ninja%20village%2C%20sunny%20golden%20light%2C%20playful%20smiles%2C%20hand%20painted%20manga%20cover%20art%2C%20warm%20amber%20and%20cream%20palette%2C%20soft%20shading%2C%20high%20detail&width=800&height=1000&seq=hot-naruto-1&orientation=portrait",
  },
  {
    id: "hot-2",
    title: "月下之约",
    author: "月见",
    category: "佐助CP",
    tags: ["宿命", "情感", "剧情"],
    rating: "9.4",
    summary: "在命运分岔的路口，两人关于约定与释然的对话，一段关于和解的安静叙事。",
    cover:
      "https://readdy.ai/api/search-image?query=melancholic%20anime%20illustration%20of%20two%20ninja%20silhouettes%20standing%20on%20a%20rock%20under%20a%20large%20crimson%20moon%2C%20promise%20and%20farewell%20mood%2C%20deep%20charcoal%20and%20warm%20red%20tones%2C%20hand%20painted%20manga%20cover%20art%2C%20cinematic%20lighting%2C%20high%20detail&width=800&height=1000&seq=hot-sasuke-1&orientation=portrait",
  },
  {
    id: "hot-3",
    title: "花瓣落下的方向",
    author: "白桦",
    category: "鼬樱",
    tags: ["含蓄", "守护", "古风"],
    rating: "9.1",
    summary: "以樱为线索串联起的一段守护故事，温柔克制里藏着无人知晓的心意。",
    cover:
      "https://readdy.ai/api/search-image?query=delicate%20anime%20illustration%20of%20cherry%20blossom%20petals%20drifting%20past%20a%20gentle%20female%20ninja%20and%20a%20mysterious%20cloaked%20figure%2C%20soft%20pink%20and%20vermilion%20tones%2C%20poetic%20tender%20mood%2C%20hand%20painted%20manga%20cover%20art%2C%20high%20detail&width=800&height=1000&seq=hot-itachi-1&orientation=portrait",
  },
  {
    id: "hot-4",
    title: "第七班的晨读",
    author: "一文字",
    category: "卡卡西",
    tags: ["温馨", "日常", "群像"],
    rating: "8.9",
    summary: "老师与学生们围坐晨读的治愈日常，微小却闪光，是卡卡西向里难得的长篇温情作。",
    cover:
      "https://readdy.ai/api/search-image?query=heartwarming%20anime%20illustration%20of%20a%20masked%20silver%20haired%20ninja%20reading%20a%20book%20under%20a%20tree%20surrounded%20by%20young%20students%2C%20soft%20morning%20sunlight%20through%20leaves%2C%20gentle%20candid%20mood%2C%20hand%20painted%20manga%20cover%20art%2C%20warm%20sand%20and%20grey%20palette%2C%20high%20detail&width=800&height=1000&seq=hot-kakashi-1&orientation=portrait",
  },
  {
    id: "hot-5",
    title: "云上一天",
    author: "鹿角",
    category: "鹿丸",
    tags: ["轻松", "生活", "吐槽"],
    rating: "8.8",
    summary: "只想偷懒的聪明人，却在一天里被各种麻烦缠上，节奏轻快又笑点密集。",
    cover:
      "https://readdy.ai/api/search-image?query=lighthearted%20anime%20illustration%20of%20a%20relaxed%20ponytail%20ninja%20lying%20on%20a%20hill%20watching%20cotton%20clouds%20with%20a%20bento%20box%20beside%20him%2C%20lazy%20summer%20mood%2C%20hand%20painted%20manga%20cover%20art%2C%20warm%20neutral%20and%20sky%20tone%20palette%2C%20soft%20light%2C%20high%20detail&width=800&height=1000&seq=hot-shikamaru-1&orientation=portrait",
  },
  {
    id: "hot-6",
    title: "沙漏",
    author: "砂砾",
    category: "我爱罗",
    tags: ["成长", "治愈", "剧情"],
    rating: "9.0",
    summary: "从孤立的沙丘到被理解的家园，一段关于重新学会信任与拥抱的长篇叙事。",
    cover:
      "https://readdy.ai/api/search-image?query=hopeful%20anime%20illustration%20of%20a%20red%20haired%20ninja%20holding%20an%20hourglass%20of%20golden%20sand%20in%20a%20desert%20turning%20into%20a%20green%20oasis%2C%20dawn%20light%2C%20warm%20amber%20palette%2C%20hand%20painted%20manga%20cover%20art%2C%20emotional%20high%20detail&width=800&height=1000&seq=hot-gaara-1&orientation=portrait",
  },
];

export const allWorks: WorkItem[] = [
  ...hotWorks,
  {
    id: "w-7",
    title: "晓风残月",
    author: "白桦",
    category: "鼬樱",
    tags: ["命运", "含蓄", "剧情"],
    rating: "8.7",
    summary: "以一场意外的相遇为起点，勾勒出两人在各自道路上默默守望的剪影。",
    cover:
      "https://readdy.ai/api/search-image?query=silent%20anime%20illustration%20of%20a%20solitary%20ninja%20in%20a%20crimson%20cloak%20gazing%20at%20a%20half%20moon%20over%20a%20water%20pond%20with%20floating%20petals%2C%20wistful%20quiet%20mood%2C%20warm%20red%20and%20ink%20tones%2C%20hand%20painted%20manga%20cover%20art%2C%20high%20detail&width=800&height=1000&seq=w-itachi-2&orientation=portrait",
  },
  {
    id: "w-8",
    title: "牵绊",
    author: "影山桑",
    category: "鸣人CP",
    tags: ["羁绊", "成长", "热血"],
    rating: "8.9",
    summary: "并肩的两个人，在一次次战斗与理解中把彼此的牵绊越磨越亮。",
    cover:
      "https://readdy.ai/api/search-image?query=dynamic%20anime%20illustration%20of%20two%20young%20ninja%20brothers%20in%20arms%20facing%20a%20glowing%20sunrise%20with%20determined%20expressions%2C%20warm%20orange%20backlight%2C%20hand%20painted%20manga%20cover%20art%2C%20high%20detail%2C%20epic%20and%20hopeful&width=800&height=1000&seq=w-naruto-2&orientation=portrait",
  },
];

export interface GuideStep {
  step: string;
  title: string;
  desc: string;
  icon: string;
}

export const guideSteps: GuideStep[] = [
  {
    step: "01",
    title: "按CP选定方向",
    desc: "先确认想看的角色组合，从鸣人CP、佐助CP到鼬樱、卡卡西、鹿丸、我爱罗，每类都有独立的剧情风格与感情基调。",
    icon: "ri-focus-3-line",
  },
  {
    step: "02",
    title: "浏览剧情标签",
    desc: "通过日常、守护、宿命、治愈等标签快速判断作品走向，也方便在同类作品之间横向比较，找到最合口味的叙事。",
    icon: "ri-price-tag-3-line",
  },
  {
    step: "03",
    title: "收藏心仪作品",
    desc: "把喜欢的同人本加入收藏夹，随时回顾剧情与分镜，也能顺着同一作者或同一CP继续发现更多好故事。",
    icon: "ri-heart-3-line",
  },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqItems: FaqItem[] = [
  {
    q: "什么是火影同人本子？",
    a: "火影同人本子是由爱好者围绕《火影忍者》世界观与角色创作的原创漫画或短篇合集。与官方剧情不同，同人本会按作者偏好重新演绎角色关系，常见的按CP（角色配对）分类，比如鸣人CP、佐助CP、鼬樱等，方便读者按想看的故事方向筛选。",
  },
  {
    q: "鸣人CP与佐助CP有什么不同？",
    a: "鸣人CP通常偏向阳光、羁绊与并肩成长，整体氛围更明亮热血；佐助CP则更多刻画孤独、复仇与救赎的复杂心绪，剧情与情感向作品居多。两者感情基调差异明显，读者可根据自己的偏好选择分类。",
  },
  {
    q: "鼬樱、卡卡西、鹿丸、我爱罗这几类有什么特色？",
    a: "鼬樱偏含蓄守护与细腻情感，卡卡西以温情日常和师恩回忆为主，鹿丸走轻松机智的反差风格，我爱罗则聚焦孤独、守护与重新学会信任。各类画风和叙事节奏都不同，可按心情挑选。",
  },
  {
    q: "在哪里可以阅读这些同人本子？",
    a: "本站提供作品分类与剧情推荐索引，帮助读者快速定位想看的故事方向。正式阅读通常需要前往作者发布的对应平台，建议关注作品标注的作者与连载信息，并支持正版创作。",
  },
  {
    q: "会持续更新新的分类与作品吗？",
    a: "会的。我们会持续跟进热门CP的优质作品，按剧情标签整理推荐，并定期补充新分类、新作者与新人气作品，让分类索引保持新鲜和好用。",
  },
  {
    q: "我可以投稿推荐自己的同人作品吗？",
    a: "欢迎！如果你创作了与火影角色相关的同人本，可以通过站内联系表单提交作品信息与简介，审核通过后会按对应CP分类收录到推荐索引中。",
  },
];

export const testimonialList = [
  {
    name: "桔梗",
    role: "同人本收藏爱好者",
    text: "按CP分类真的很省心，鼬樱和卡卡西的分类很全，一下子就能找到想看的那类故事，再也不用大海捞针了。",
  },
  {
    name: "阿澈",
    role: "剧情向读者",
    text: "标签整理得很清楚，宿命、守护、治愈这些词一下就能对作品有个大概判断，推荐质量一直很稳。",
  },
  {
    name: "木子",
    role: "同人创作者",
    text: "投稿流程很顺畅，我的作品被归到对应CP后也方便了不少读者找到，能感觉到是在认真做分类。",
  },
];